import { Clock } from "lucide-react";

export function PlaceholderPanel({ icon: Icon = Clock, title, description }) {
  return (
    <div className="bg-card border border-border border-dashed rounded-xl p-10 text-center" data-testid="placeholder-panel">
      <div className="h-12 w-12 rounded-full bg-muted flex items-center justify-center mx-auto mb-4">
        <Icon className="h-6 w-6 text-muted-foreground" />
      </div>
      <h3 className="font-semibold text-foreground">{title}</h3>
      <p className="text-sm text-muted-foreground mt-2 max-w-md mx-auto">{description}</p>
      <span className="inline-block mt-4 text-xs font-medium uppercase tracking-wider text-primary/70 bg-primary/10 rounded-full px-3 py-1">
        Coming in a later phase
      </span>
    </div>
  );
}
